/* En-tête « façon Loban » — ÉCRIT À LA MAIN depuis le lot 1 (n'est plus généré par construire.py).
   Document de conception : docs/superpowers/specs/2026-10-03-moola-facon-loban.md, §§ 4.1, 4.2 et 10.
   1. Hauteur publiée dans --moola-entete-h (ResizeObserver) : défilement vers une ancre, réserve du hero.
   2. Accueil ([data-transparent]) : en haut de page, en-tête transparent posé sur la grande image ; dès que sa ligne
      médiane quitte l'écran (scrollY ≥ 40 % de sa hauteur — le centre du burger est encore visible juste avant), il
      revient PLEIN et COLLANT en glissant depuis la position où il se trouvait (transform seul, en-tête hors du flux :
      CLS 0) ; en remontant sous ce seuil, glissement inverse puis retour à l'état transparent. Aucune zone morte
      (défaut relevé chez Loban : aucun en-tête visible entre 119 et 500 px de défilement).
   3. Recherche dépliée sous l'en-tête. Sans JavaScript, la loupe est un lien vers /search.
   4. Pastille du panier : évènement « moola:panier » {item_count} (émis par la fiche et la page panier).
   5. Déroulants de la barre (≥ 1150 px) : <details> natifs ouverts au CLIC (un survol n'ouvre rien), un seul ouvert à
      la fois, fermeture au clic extérieur et à Échap, aria-expanded sur le <summary>. Un déroulant ouvert ou la
      recherche dépliée remplissent l'en-tête (fond blanc), même en haut de l'accueil. */
(function () {
  var entete = document.querySelector('[data-moola-entete]');
  if (!entete) { return; }
  var racine = document.documentElement;
  var reduit = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  // 1. Hauteur
  function publier() { racine.style.setProperty('--moola-entete-h', entete.offsetHeight + 'px'); }
  publier();
  if ('ResizeObserver' in window) { new ResizeObserver(publier).observe(entete); } else { window.addEventListener('resize', publier); }

  // 1 bis. Hauteur du bandeau cookies quand il est AFFICHÉ (0 sinon), dans --moola-cookies-h : les éléments fixés en bas
  // (bouton flottant des filtres, barre d'achat de la fiche) se placent au-dessus de lui, jamais dessous.
  var bandeau = document.querySelector('.moola-cookies');
  var publierCookies = function () {
    var vu = bandeau && !bandeau.hidden && getComputedStyle(bandeau).display !== 'none' && getComputedStyle(bandeau).visibility !== 'hidden';
    racine.style.setProperty('--moola-cookies-h', (vu ? Math.ceil(bandeau.getBoundingClientRect().height) : 0) + 'px');
  };
  if (bandeau) {
    publierCookies();
    new MutationObserver(publierCookies).observe(bandeau, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    if ('ResizeObserver' in window) { new ResizeObserver(publierCookies).observe(bandeau); }
  }

  // 2. Transparence sur la grande image de l'accueil
  if (entete.hasAttribute('data-transparent')) {
    var colle = false, minuteur = 0, demande = false;
    var sortir = function () {
      entete.classList.remove('est-colle', 'est-sortant');
    };
    var mettreAJour = function () {
      demande = false;
      var h = entete.offsetHeight, seuil = Math.round(h * 0.4);
      if (!colle && window.scrollY >= seuil) {
        colle = true; clearTimeout(minuteur);
        // Départ du glissement = là où l'en-tête transparent se trouvait (en partie sorti de l'écran) : aucun saut.
        entete.style.setProperty('--moola-depart', -Math.min(window.scrollY, h) + 'px');
        entete.classList.remove('est-sortant'); entete.classList.add('est-colle');
      } else if (colle && window.scrollY < seuil) {
        colle = false;
        if (reduit.matches) { sortir(); return; }
        entete.classList.add('est-sortant');
        minuteur = setTimeout(sortir, 150);
      }
    };
    window.addEventListener('scroll', function () { if (!demande) { demande = true; requestAnimationFrame(mettreAJour); } }, { passive: true });
    mettreAJour();
  }

  // 3. Recherche
  var loupe = entete.querySelector('[data-moola-recherche-bouton]');
  var form = document.getElementById('moola-recherche');
  var champ = form && form.querySelector('input[type="search"]');
  var groupes = [].slice.call(entete.querySelectorAll('[data-moola-deroulant]'));
  function remplir() {
    var ouvert = (form && !form.hidden) || groupes.some(function (d) { return d.open; });
    entete.classList.toggle('est-plein', ouvert);
  }
  if (loupe && form && champ) {
    loupe.setAttribute('role', 'button');
    loupe.setAttribute('aria-controls', form.id);
    loupe.setAttribute('aria-expanded', 'false');
    var basculer = function (ouvrir) {
      form.hidden = !ouvrir;
      loupe.setAttribute('aria-expanded', String(ouvrir));
      loupe.setAttribute('aria-label', ouvrir ? 'Fermer la recherche' : 'Rechercher');
      if (ouvrir) { groupes.forEach(function (d) { d.open = false; }); champ.focus({ preventScroll: true }); } else { champ.value = ''; }
      remplir();
    };
    // Texte d'aide : la version longue (« Rechercher parmi 1620 références », 243 px) ne tient pas dans le champ sous 600 px.
    var aideLongue = champ.getAttribute('placeholder'), aideCourte = champ.getAttribute('data-aide-court');
    var etroit = window.matchMedia('(max-width: 599px)');
    var aide = function () { if (aideCourte) { champ.setAttribute('placeholder', etroit.matches ? aideCourte : aideLongue); } };
    aide();
    if (etroit.addEventListener) { etroit.addEventListener('change', aide); }
    loupe.addEventListener('click', function (e) { e.preventDefault(); basculer(form.hidden); });
    loupe.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); basculer(form.hidden); } });
    champ.addEventListener('keydown', function (e) { if (e.key === 'Escape') { basculer(false); loupe.focus(); } });
    // Recherche vide : le catalogue entier plutôt qu'une page de résultats vide.
    form.addEventListener('submit', function (e) { if (!champ.value.trim()) { e.preventDefault(); window.location.href = '/collections/all'; } });
  }

  // 4. Pastille du panier
  var panier = entete.querySelector('[data-moola-panier]');
  var pastille = entete.querySelector('[data-moola-pastille]');
  if (panier && pastille) {
    document.addEventListener('moola:panier', function (e) {
      var d = e.detail || {};
      var n = Number(d.item_count != null ? d.item_count : d.total) || 0;
      pastille.textContent = String(n);
      pastille.hidden = n === 0;
      panier.setAttribute('aria-label', n === 0 ? 'Panier, vide' : 'Panier, ' + n + ' article' + (n > 1 ? 's' : ''));
    });
  }

  // 5. Déroulants de la barre (ordinateur)
  groupes.forEach(function (d) {
    var s = d.querySelector('summary');
    s.setAttribute('aria-expanded', 'false');
    d.addEventListener('toggle', function () {
      s.setAttribute('aria-expanded', String(d.open));
      if (d.open) {
        groupes.forEach(function (x) { if (x !== d) { x.open = false; } });
        if (form && !form.hidden && loupe) { form.hidden = true; loupe.setAttribute('aria-expanded', 'false'); loupe.setAttribute('aria-label', 'Rechercher'); }
      }
      remplir();
    });
    d.addEventListener('focusout', function (e) {
      if (d.open && e.relatedTarget && !d.contains(e.relatedTarget)) { d.open = false; }
    });
  });
  if (groupes.length) {
    document.addEventListener('click', function (e) {
      if (!e.target.closest || e.target.closest('[data-moola-deroulant]')) { return; }
      groupes.forEach(function (d) { d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') { return; }
      groupes.forEach(function (d) {
        if (!d.open) { return; }
        d.open = false;
        d.querySelector('summary').focus();
      });
    });
  }
})();
